import { useEffect, useState } from "react"
import { API_STATUS } from "../../constants"
import { GetNewFaces } from "../../apis/user/get_new_faces";
import { GetNewClients } from "../../apis/user/get_new_clients";

export default function NewClients() {
    const [userdata, setUserData] = useState([]);
    const [faceApi, setFaceApi] = useState(API_STATUS);

    useEffect(() => {
        GetNewClients(setFaceApi);
    }, []);

    useEffect(() => {
        if (!faceApi.isLoader && !faceApi.isError && faceApi.data != null) {
            if (faceApi.data.status === 1) {
                setUserData(faceApi.data.data);
            }
        }
    }, [faceApi]);

    return <div className="bg-white rounded-xl shadow-sm p-5 px-6 border1 dark:bg-dark2">

        <div className="flex justify-between text-black dark:text-white">
            <h3 className="font-bold text-base"> New Clients </h3>
            <button type="button"> <ion-icon name="sync-outline" className="text-xl"></ion-icon> </button>
        </div>
        {
            userdata !== null && userdata.length > 0 &&

            <div className="space-y-4 capitalize text-xs font-normal mt-5 mb-2 text-gray-500 dark:text-white/80">
                {
                    userdata.map((item, i) =>

                        <div className="flex items-center gap-3">
                            <a key={i} href={'/profile/' + item.userId} >
                                <img src={item.userPic} alt="" className="bg-gray-200 rounded-full w-10 h-10" />
                            </a>
                            <div className="flex-1">
                                <a href={'/profile/' + item.userId}><h4 className="font-semibold text-sm text-black dark:text-white">  {item.firstName + ' ' + item.lastName}</h4></a>
                                <div className="mt-0.5"> {item.username} </div>
                            </div>
                            {/* <button type="button" className="text-sm rounded-full py-1.5 px-4 font-semibold bg-secondery"> Follow </button> */}
                        </div>
                    )}

            </div>
        }
    </div>
}